import { Button } from "@memento/ui/Button";
import Image from "next/image";
import A11yButton from "src/components/A11yButton";
import { ThemeBodyText } from "src/components/GroupVideoTheme/ThemeBodyText";
import { ThemeBodyTextSecondary } from "src/components/GroupVideoTheme/ThemeBodyTextSecondary";
import { CardThemeIdentifier } from "src/components/GroupVideoTheme/card-theme-utils";

type AppStoreButtonProps = {
  onClick: () => void;
  height?: number;
  width?: number;
};

const AppStoreButton = ({
  onClick,
  height = 48,
  width = 140,
}: AppStoreButtonProps) => {
  return (
    <A11yButton onClick={onClick}>
      <Image
        src="/images/buttons/btn-download-app-store.png"
        alt="Download on the App Store"
        height={height}
        width={width}
      />
    </A11yButton>
  );
};

export interface AppStoreButtonLabeledProps {
  callback?: () => void;
  deepLinkUrl: string;
  hasApp: boolean;
  onPostTextClick?: () => void;
  preText?: string;
  postText?: string;
  themeId?: CardThemeIdentifier; // Affects color of pre/postText
}

export const AppStoreButtonLabeled = ({
  deepLinkUrl,
  hasApp = false,
  callback = () => null,
  onPostTextClick = () => null,
  postText = "",
  preText = "",
  themeId = "",
}: AppStoreButtonLabeledProps) => {
  const followDeepLink = () => {
    if (deepLinkUrl) {
      window?.open(deepLinkUrl);
    }
    callback();
  };

  return (
    <div className="flex flex-col items-center">
      {preText ? (
        <p className="mb-2 font-bold">
          <ThemeBodyText themeId={themeId}>{preText}</ThemeBodyText>
        </p>
      ) : null}
      {hasApp ? (
        <Button variant="primary">Launch App</Button>
      ) : (
        <AppStoreButton onClick={followDeepLink} />
      )}
      {postText ? (
        <div
          className="mt-4 text-sm"
          onClick={onPostTextClick}
          onKeyDown={undefined}
          tabIndex={0}
          role="button"
        >
          <ThemeBodyTextSecondary themeId={themeId}>
            {postText}
          </ThemeBodyTextSecondary>
        </div>
      ) : null}
    </div>
  );
};
